import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { config } from "../../../utils/config";
// import { tokenDecode } from "../../../utils/helper";
import axios from "axios";

// Get the seller ID from the token
// const decoded = tokenDecode();
// const seller_id = decoded?.data?.user?.seller_id;

// Extract API endpoint and access token
const { apiEndpoint } = config;
// const accessToken = localStorage.getItem("us_st_d");

interface SettingState {
  loader: boolean;
  settingColor: any;
  error: string | null;
}

const initialState: SettingState = {
  loader: false,
  settingColor: null,
  error: null,
};

// Async thunk for fetching setting color data
export const fetchSettingColor = createAsyncThunk(
  "setting/fetchSettingColor",
  async (seller_id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${apiEndpoint}/calendar/settings/get/${seller_id}`,
      );
      if (response?.data?.success) {
        return response?.data?.settings;
      } else {
        return rejectWithValue("Failed to fetch setting color data");
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

// Slice for managing setting color state
const settingColorSlice = createSlice({
  name: "settingColor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettingColor.pending, (state) => {
        state.loader = true;
        state.error = null;
        state.settingColor = null;
      })
      .addCase(
        fetchSettingColor.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loader = false;
          state.settingColor = action.payload;
          state.error = null;
        },
      )
      .addCase(fetchSettingColor.rejected, (state, action) => {
        state.loader = false;
        state.settingColor = null;
        state.error = action.payload as string;
      });
  },
});

export default settingColorSlice.reducer;
